import api from "@/api"

const state = {
  partnerList: [],
  partnerTypes: [],
  partnerDetail: {},
  packageList: [],
  packageDetail: {},
  costMapping: [],
  costMappingDetail: {},
  partnerVehicle: [],
  baseCost: [],
  baseCostDetail: {},
  deliveryServices: [],
  selfRegistration: []
}
const actions = {
  getPartners({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.partner.partnerList(params).then(
        (response) => {
          commit("setPartners", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getDeliveryServices({ commit }) {
    return new Promise((resolve, reject) => {
      api.partner.deliveryServices().then(
        (response) => {
          commit("setDeliveryServices", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getPackages({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      api.partner.packages(id).then(
        (response) => {
          commit("setPackageList", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateStatus({ commit }, { id, payloads }) {
    return new Promise((resolve, reject) => {
      api.partner.updateStatus(id, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getPartnerDetail({ commit }, { partnerId }) {
    return new Promise((resolve, reject) => {
      api.partner.partnerDetail(partnerId).then(
        (response) => {
          commit("setPartnerDetail", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getPartnerTypes({ commit }) {
    return new Promise((resolve, reject) => {
      api.partner.partnerTypes().then(
        (response) => {
          commit("setPartnerTypes", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  createPartner({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.partner.createPartner(payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getPackageList({ commit }, { id, params }) {
    return new Promise((resolve, reject) => {
      api.partner.packageList(id, params).then(
        (response) => {
          commit("setPackageList", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getPackageDetail({ commit }, { partnerId, packageId }) {
    return new Promise((resolve, reject) => {
      api.partner.packageDetail(partnerId, packageId).then(
        (response) => {
          commit("setPackageDetail", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  createPackage({ _ }, { id, payloads }) {
    return new Promise((resolve, reject) => {
      api.partner.createPackage(id, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updatePackage({ _ }, { partnerId, packageId, payloads }) {
    return new Promise((resolve, reject) => {
      api.partner.updatePackage(partnerId, packageId, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  removePackage({ _ }, { partnerId, packageId }) {
    return new Promise((resolve, reject) => {
      api.partner.removePackage(partnerId, packageId).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getCostMapping({ commit }, { partnerId, params }) {
    return new Promise((resolve, reject) => {
      api.partner.costMapping(partnerId, params).then(
        (response) => {
          commit("setCostMapping", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getCostMappingDetail({ commit }, { partnerId, costMappingId }) {
    return new Promise((resolve, reject) => {
      api.partner.costMappingDetail(partnerId, costMappingId).then(
        (response) => {
          commit("setCostMappingDetail", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  duplicateCostMapping({ _ }, { partnerId, costMappingId, payloads }) {
    return new Promise((resolve, reject) => {
      api.partner.duplicateCostMapping(partnerId, costMappingId, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateCostMapping({ _ }, { partnerId, costMappingId, payloads }) {
    return new Promise((resolve, reject) => {
      api.partner.updateCostMapping(partnerId, costMappingId, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  createCostMapping({ _ }, { partnerId, payloads }) {
    return new Promise((resolve, reject) => {
      api.partner.createCostMapping(partnerId, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  removeCostMapping({ _ }, { partnerId, costMappingId }) {
    return new Promise((resolve, reject) => {
      api.partner.removeCostMapping(partnerId, costMappingId).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getBaseCost({ commit }, { partnerId, costMappingId, params }) {
    return new Promise((resolve, reject) => {
      api.partner.baseCost(partnerId, costMappingId, params).then(
        (response) => {
          commit("setBaseCost", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getBaseCostDetail({ commit }, { partnerId, costMappingId, baseCostId }) {
    return new Promise((resolve, reject) => {
      api.partner.baseCostDetail(partnerId, costMappingId, baseCostId).then(
        (response) => {
          commit("setBaseCostDetail", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  createBaseCost({ _ }, { partnerId, costMappingId, payloads }) {
    return new Promise((resolve, reject) => {
      api.partner.createBaseCost(partnerId, costMappingId, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  removeBaseCost({ _ }, { partnerId, costMappingId, baseCostId }) {
    return new Promise((resolve, reject) => {
      api.partner.removeBaseCost(partnerId, costMappingId, baseCostId).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateBaseCost({ _ }, { partnerId, costMappingId, baseCostId, payloads }) {
    return new Promise((resolve, reject) => {
      api.partner
        .updateBaseCost(partnerId, costMappingId, baseCostId, payloads)
        .then(
          (response) => {
            resolve(response)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
  getPartnerVehicle({ commit }, { partnerId, params }) {
    return new Promise((resolve, reject) => {
      api.partner.partnerVehicle(partnerId, params).then(
        (response) => {
          commit("setPartnerVehicle", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getSelfRegistration({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.partner.selfRegistration(params).then(
        (response) => {
          commit("setSelfRegistration", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setSelfRegistration(state, value) {
    state.selfRegistration = value
  },
  setPartners(state, value) {
    state.partnerList = value
  },
  setPartnerTypes(state, value) {
    state.partnerTypes = value
  },
  setPartnerDetail(state, value) {
    state.partnerDetail = value
  },
  setPackageList(state, value) {
    state.packageList = value
  },
  setPackageDetail(state, value) {
    state.packageDetail = value
  },
  setCostMapping(state, value) {
    state.costMapping = value
  },
  setCostMappingDetail(state, value) {
    state.costMappingDetail = value
  },
  setBaseCost(state, value) {
    state.baseCost = value
  },
  setBaseCostDetail(state, value) {
    state.baseCostDetail = value
  },
  setPartnerVehicle(state, value) {
    state.partnerVehicle = value
  },
  setDeliveryServices(state, value) {
    state.deliveryServices = value
  }
}
const getters = {
  partnerList: (state) => state.partnerList,
  partnerDetail: (state) => state.partnerDetail,
  partnerTypes: (state) => state.partnerTypes,
  packageList: (state) => state.packageList,
  packageDetail: (state) => state.packageDetail,
  costMapping: (state) => state.costMapping,
  costMappingDetail: (state) => state.costMappingDetail,
  baseCost: (state) => state.baseCost,
  baseCostDetail: (state) => state.baseCostDetail,
  partnerVehicle: (state) => state.partnerVehicle,
  deliveryServices: (state) => state.deliveryServices,
  selfRegistration: (state) => state.selfRegistration
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
